import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDivisions = () => {
  return (
    <g>
      <path d="M8 1a2 2 0 0 1 .751 3.854L8.75 7.25H14a.75.75 0 0 1 .743.648L14.75 8l.001 3.146a2 2 0 1 1-1.501 0V8.75h-4.5l.001 2.396a2 2 0 1 1-1.501 0V4.854A2.007 2.007 0 0 1 6.146 3.75L2.75 3.75l.001 7.396a2 2 0 1 1-1.501 0V3a.75.75 0 0 1 .648-.743L2 2.25h4.145A2 2 0 0 1 8 1z" />
    </g>
  );
};

export default withIcon(IconDivisions);
